import React from "react";
import ArrowLeftOutlinedIcon from "@mui/icons-material/ArrowLeftOutlined";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { ProductContext } from "../../../Contexts/ProductContext";

const EditProduct = () => {
  const { fetchProducts } = React.useContext(ProductContext);
  const apiUrl = process.env.REACT_APP_API_URL;
  const { id } = useParams();
  const [formData, setFormData] = React.useState({
    title: "",
    prdStock: "",
    prdCategory: "",
    images: [],
    prdIndustry: "",
    prdCondition: "",
    prdBrand: "",
    prdType: "",
    ref_number: "",
    opr_weight: "",
    manufacture: "",
    prdModel: "",
    prdYear: "",
    prdLocation: "",
    prdDelivery: "",
    productColor: "",
    shortDescription: "",
    longDescription: "",
  });

  const navigate = useNavigate();

  const [existingImages, setExistingImages] = React.useState([]);
  const [ploading, setpLoading] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const fetchProductData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}getProductById/${id}`);
      if (response.status === 200) {
        setFormData(response.data);
        setExistingImages(response.data.images || []);
      } else {
        toast.error("Failed to load product data.");
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      toast.error("Error fetching product data.");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchProductData(); // Fetch product data when component mounts
  }, [id]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlebase64 = (event) => {
    const files = Array.from(event.target.files);
    const imagePromises = files.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => {
          console.error("Error reading file:", error);
          toast.error("Failed to upload image.");
          reject(error);
        };
      });
    });

    Promise.all(imagePromises)
      .then((images) => {
        setFormData((prevState) => ({ ...prevState, images }));
      })
      .catch((error) => {
        console.error("Error processing files:", error);
      });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setpLoading(true);
      const finalFormData = {
        ...formData,
        images: formData.images.length > 0 ? formData.images : existingImages,
      };
      const response = await axios.put(
        `${apiUrl}updateProduct/${id}`,
        finalFormData
      );
      if (response.status === 200) {
        fetchProducts();
        navigate("/admin/dashboard/products", {
          state: { message: "Product updated successfully." },
        });
      } else {
        toast.error("Failed to update product.");
      }
    } catch (error) {
      setpLoading(false);
      if (error.response) {
        console.error("Error updating product:", error.response.data);
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        toast.error("Error updating product.");
        console.error("Error updating product:", error);
      }
    }
  };
  return (
    <div className="dashboard-content-wrap p-10">
      <ToastContainer />
      <div className="box-card">
        <div className="box-card-title mb-6">
          <h1 className="text-lg font-medium flex items-center">
            <Link to="/admin/dashboard/products" className="goBack mr-3">
              <ArrowLeftOutlinedIcon sx={{ fontSize: "20px", color: "#fff" }} />
            </Link>
            Edit Product
          </h1>
        </div>
        <div className="box-card-body">
          <form onSubmit={handleSubmit} className="">
            {loading ? (
              <div className="w-full text-center mb-5">
                <p>Loading product data...</p> {/* Loading message */}
              </div>
            ) : (
              <div className="flex gap-4 flex-wrap">
                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Product Name
                    </label>
                    <input
                      type="text"
                      name="title"
                      className="form-control"
                      placeholder="Product Name"
                      value={formData.title}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Stock Information
                    </label>
                    <select
                      className="form-control"
                      name="prdStock"
                      value={formData.prdStock}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Stock</option>
                      <option value="In Stock">In Stock</option>
                      <option value="Out of Stock">Out of Stock</option>
                    </select>
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Product Category
                    </label>
                    <select
                      className="form-control"
                      name="prdCategory"
                      value={formData.prdCategory}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Category</option>
                      <option value="Rent">Rent</option>
                      <option value="Buy">Buy</option>
                    </select>
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Product Image(s)
                    </label>
                    <input
                      type="file"
                      name="images"
                      className="form-control"
                      placeholder="Product Name"
                      multiple
                      onChange={handlebase64}
                      required={existingImages.length === 0}
                    />
                  </div>

                  <div className="flex gap-5 flex-wrap">
                    {formData.images.map((image, index) => (
                      <div key={index} className="w-1/4">
                        <img
                          src={image}
                          alt="Product Image"
                          className="w-full h-20 object-cover rounded-md mt-3"
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">Industry</label>
                    <select
                      className="form-control"
                      name="prdIndustry"
                      value={formData.prdIndustry}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Industry</option>
                      <option value="Construction">Construction</option>
                      <option value="Quarry & Aggregate">
                        Quarry & Aggregate
                      </option>
                      <option value="Mining">Mining</option>
                      <option value="Oil & Gas">Oil & Gas</option>
                    </select>
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Product Condition
                    </label>
                    <select
                      className="form-control"
                      name="prdCondition"
                      value={formData.prdCondition}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Condition</option>
                      <option value="Brand New">Brand New</option>
                      <option value="Used">Used</option>
                    </select>
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Product Type
                    </label>
                    <select
                      className="form-control"
                      name="prdType"
                      value={formData.prdType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Type</option>
                      <option value="Mobile Cranes">Mobile Cranes</option>
                      <option value="Forklifts">Forklifts</option>
                      <option value="Excavators">Excavators</option>
                      <option value="Loaders">Loaders</option>
                      <option value="Roller">Roller</option>
                      <option value="Off Road Trucks">Off Road Trucks</option>
                      <option value="Excavators">Excavators</option>
                      <option value="Crawler Cranes">Crawler Cranes</option>
                      <option value="Crawler Dozers">Crawler Dozers</option>
                      <option value="Wheel Loaders">Wheel Loaders</option>
                      <option value="Mobile Cranes">Mobile Cranes</option>
                      <option value="Compactors">Compactors</option>
                    </select>
                  </div>
                </div>
                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Product Brand
                    </label>
                    <select
                      className="form-control"
                      name="prdBrand"
                      value={formData.prdBrand}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Brand</option>
                      <optgroup label="Mobile Cranes">
                        <option value="Kato">Kato</option>
                        <option value="Tadano">Tadano</option>
                        <option value="Sany">Sany</option>
                        <option value="Sumitomo">Sumitomo</option>
                        <option value="Grove">Grove</option>
                        <option value="Kobelco">Kobelco</option>
                        <option value="Liebherr">Liebherr</option>
                        <option value="Zoomlion">Zoomlion</option>
                        <option value="Terex">Terex</option>
                        <option value="Xcmg">Xcmg</option>
                      </optgroup>

                      <optgroup label="Forklifts">
                        <option value="Warehouse">Warehouse</option>
                        <option value="Side Loader">Side Loader</option>
                        <option value="Counterbalance">Counterbalance</option>
                        <option value="Telehandler">Telehandler</option>
                        <option value="Heavy-Duty">Heavy-Duty</option>
                        <option value="Rough Terrain">Rough Terrain</option>
                        <option value="Pallet Jack">Pallet Jack</option>
                        <option value="Walkie Stacker">Walkie Stacker</option>
                        <option value="Order Picker">Order Picker</option>
                        <option value="Peach Truck">Peach Truck</option>
                      </optgroup>

                      <optgroup label="Excavators">
                        <option value="Crawler Excavators">
                          Crawler Excavators
                        </option>
                        <option value="Wheeled Excavators">
                          Wheeled Excavators
                        </option>
                        <option value="Dragline Excavators">
                          Dragline Excavators
                        </option>
                        <option value="Suction Excavators">
                          Suction Excavators
                        </option>
                        <option value="Skid Steer Excavators">
                          Skid Steer Excavators
                        </option>
                        <option value="Long Reach Excavators">
                          Long Reach Excavators
                        </option>
                        <option value="Mini Excavators">Mini Excavators</option>
                      </optgroup>

                      <optgroup label="Loader">
                        <option value="Backhoe Loader">Backhoe Loader</option>
                        <option value="Skid Steer Loader">
                          Skid Steer Loader
                        </option>
                      </optgroup>

                      <optgroup label="Roller">
                        <option value="Drum Roller">Drum Roller</option>
                        <option value="Tamping Roller">Tamping Roller</option>
                        <option value="Padfoot Roller">Padfoot Roller</option>
                        <option value="Vibratory Roller">
                          Vibratory Roller
                        </option>
                        <option value="Smooth Drum Roller">
                          Smooth Drum Roller
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Reference Number
                    </label>
                    <input
                      type="text"
                      name="ref_number"
                      className="form-control"
                      placeholder="Reference Number"
                      value={formData.ref_number}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Operating Weight <small>(In KGs)</small>
                    </label>
                    <input
                      type="text"
                      name="opr_weight"
                      className="form-control"
                      placeholder="Operating Weight"
                      value={formData.opr_weight}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Country of Manufacture
                    </label>
                    <input
                      type="text"
                      name="manufacture"
                      className="form-control"
                      placeholder="Manufacturer"
                      value={formData.manufacture}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">Model</label>
                    <input
                      type="text"
                      name="prdModel"
                      className="form-control"
                      placeholder="Product Model"
                      value={formData.prdModel}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">Year</label>
                    <input
                      type="text"
                      name="prdYear"
                      className="form-control"
                      placeholder="Manufacturing Year"
                      value={formData.prdYear}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Product Location
                    </label>
                    <input
                      type="text"
                      name="prdLocation"
                      className="form-control"
                      placeholder="Location"
                      value={formData.prdLocation}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Estimated Delivery Time
                    </label>
                    <input
                      type="text"
                      name="prdDelivery"
                      className="form-control"
                      placeholder="Delivery Time"
                      value={formData.prdDelivery}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Product Color
                    </label>
                    <input
                      type="text"
                      name="productColor"
                      className="form-control"
                      placeholder="Product Color"
                      value={formData.productColor}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Short Description
                    </label>
                    <textarea
                      rows="5"
                      name="shortDescription"
                      className="form-control"
                      placeholder="Short Description"
                      value={formData.shortDescription}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>

                <div className="w-[48%] mb-5">
                  <div class="form-group">
                    <label className="text-sm mb-2 pl-1 block">
                      Long Description
                    </label>
                    <textarea
                      rows="5"
                      name="longDescription"
                      className="form-control"
                      placeholder="Long Description"
                      value={formData.longDescription}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>

                {ploading ? (
                  <button
                    type="submit"
                    className="bg-[#8badf7] shadow-lg px-6 py-3 text-sm rounded-lg text-white uppercase mt-3 flex items-center justify-center"
                  >
                    Edit product, please wait....
                    <LoginOutlinedIcon
                      sx={{ marginLeft: "15px", fontSize: "20px" }}
                    />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="primary-bg shadow-lg px-6 py-3 text-sm rounded-lg text-white uppercase mt-3 flex items-center justify-center"
                  >
                    Edit Product
                    <LoginOutlinedIcon
                      sx={{ marginLeft: "15px", fontSize: "20px" }}
                    />
                  </button>
                )}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditProduct;
